/* =========================================================
   HOME DECORE — Collection Page JS
   AJAX filtering/sorting via Storefront Search & Discovery,
   infinite scroll, quick view modal
   ========================================================= */
(function () {
  'use strict';

  var collectionRoot = document.querySelector('[data-collection-root]');
  if (!collectionRoot) return;

  var grid = collectionRoot.querySelector('[data-product-grid]');
  var toolbar = collectionRoot.querySelector('[data-collection-toolbar]');
  var sentinel = collectionRoot.querySelector('[data-infinite-scroll-sentinel]');
  var loadMoreBtn = collectionRoot.querySelector('[data-load-more]');
  var resultCount = collectionRoot.querySelector('[data-result-count]');
  var activeFiltersWrap = collectionRoot.querySelector('[data-active-filters]');
  var baseUrl = collectionRoot.dataset.collectionUrl || window.location.pathname;
  var infiniteEnabled = collectionRoot.dataset.infiniteScroll === 'true';

  function buildUrl(params) {
    var url = new URL(baseUrl, window.location.origin);
    params.forEach(function (value, key) { url.searchParams.append(key, value); });
    return url;
  }

  function currentParams() {
    return new URLSearchParams(window.location.search);
  }

  function fetchAndRender(params, opts) {
    opts = opts || {};
    var url = buildUrl(params);
    url.searchParams.set('section_id', collectionRoot.dataset.sectionId);

    if (grid) grid.classList.add('is-loading');

    return fetch(url.toString())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-product-grid]');
        var newFilters = doc.querySelector('[data-filters-sidebar]');
        var newCount = doc.querySelector('[data-result-count]');
        var newActiveFilters = doc.querySelector('[data-active-filters]');
        var newPagination = doc.querySelector('[data-pagination]');

        if (newGrid && grid) {
          if (opts.append) {
            grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
          } else {
            grid.innerHTML = newGrid.innerHTML;
          }
        }
        if (newFilters) {
          var filtersSidebar = collectionRoot.querySelector('[data-filters-sidebar]');
          if (filtersSidebar) filtersSidebar.innerHTML = newFilters.innerHTML;
          var filtersDrawerBody = collectionRoot.querySelector('[data-filters-drawer-body]');
          if (filtersDrawerBody) filtersDrawerBody.innerHTML = newFilters.innerHTML;
        }
        if (newCount && resultCount) resultCount.textContent = newCount.textContent;
        if (newActiveFilters && activeFiltersWrap) activeFiltersWrap.outerHTML = newActiveFilters.outerHTML;

        var paginationWrap = collectionRoot.querySelector('[data-pagination]');
        if (paginationWrap) {
          paginationWrap.outerHTML = newPagination ? newPagination.outerHTML : '';
        }

        if (!opts.append) {
          window.history.pushState({}, '', '?' + params.toString());
        }
        collectionRoot.dispatchEvent(new CustomEvent('collection:updated'));
      })
      .finally(function () {
        if (grid) grid.classList.remove('is-loading');
      });
  }

  /* ---------------- Filter checkboxes / sidebar + drawer ---------------- */
  collectionRoot.addEventListener('change', function (e) {
    var filterInput = e.target.closest('[data-filter-input]');
    if (!filterInput) return;

    var params = currentParams();
    var name = filterInput.name;
    var value = filterInput.value;

    if (filterInput.type === 'checkbox') {
      if (filterInput.checked) {
        params.append(name, value);
      } else {
        var all = params.getAll(name).filter(function (v) { return v !== value; });
        params.delete(name);
        all.forEach(function (v) { params.append(name, v); });
      }
    } else {
      params.set(name, value);
    }
    params.delete('page');
    fetchAndRender(params, { append: false });
  });

  // Price range apply
  collectionRoot.addEventListener('click', function (e) {
    if (e.target.closest('[data-apply-price-filter]')) {
      var wrap = e.target.closest('[data-price-filter]');
      var min = wrap.querySelector('[data-price-min]').value;
      var max = wrap.querySelector('[data-price-max]').value;
      var params = currentParams();
      if (min) { params.set(wrap.dataset.minParam, min); } else { params.delete(wrap.dataset.minParam); }
      if (max) { params.set(wrap.dataset.maxParam, max); } else { params.delete(wrap.dataset.maxParam); }
      fetchAndRender(params);
    }

    var removePill = e.target.closest('[data-remove-filter]');
    if (removePill) {
      var url = new URL(removePill.getAttribute('data-remove-filter'), window.location.origin);
      fetchAndRender(url.searchParams);
    }

    if (e.target.closest('[data-clear-filters]')) {
      fetchAndRender(new URLSearchParams());
    }

    var groupTitle = e.target.closest('[data-filter-group-toggle]');
    if (groupTitle) {
      groupTitle.closest('.filter-group').classList.toggle('is-collapsed');
    }
  });

  /* ---------------- Sort ---------------- */
  var sortSelect = collectionRoot.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var params = currentParams();
      params.set('sort_by', sortSelect.value);
      fetchAndRender(params);
    });
  }

  /* ---------------- Infinite scroll / Load more ---------------- */
  function loadNextPage() {
    var nextLink = collectionRoot.querySelector('[data-pagination] [data-next-page]');
    if (!nextLink) return;
    var url = new URL(nextLink.href);
    fetchAndRender(url.searchParams, { append: true });
  }

  if (loadMoreBtn) {
    collectionRoot.addEventListener('click', function (e) {
      if (e.target.closest('[data-load-more]')) {
        loadNextPage();
      }
    });
  }

  if (infiniteEnabled && sentinel && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) loadNextPage();
      });
    }, { rootMargin: '600px' });
    io.observe(sentinel);
  }

  /* ---------------- Quick add (collection grid product cards) ----------------
     NOTE: global.js also has a quick-add handler that covers non-collection pages.
     On collection pages this handler fires; _quickAddPending flag prevents double execution. */
  document.addEventListener('click', function (e) {
    var quickAddBtn = e.target.closest('[data-quick-add-btn]');
    if (!quickAddBtn) return;
    if (quickAddBtn._quickAddPending) return;      // already handled by global.js guard
    var variantId = quickAddBtn.getAttribute('data-variant-id');
    if (!variantId) return;
    if (quickAddBtn.getAttribute('aria-disabled') === 'true') return;

    quickAddBtn._quickAddPending = true;
    var originalText = quickAddBtn.innerHTML;
    quickAddBtn.setAttribute('aria-disabled', 'true');
    quickAddBtn.innerHTML = 'Adding…';

    window.HomeDecore.CartAPI.add([{ id: variantId, quantity: 1 }])
      .then(function () { return window.HomeDecore.refreshCart(); })
      .then(function () {
        var drawer = document.querySelector('[data-cart-drawer]');
        if (drawer) window.HomeDecore.openOverlay(drawer);
        quickAddBtn.innerHTML = '&#10003; Added';
        setTimeout(function () { quickAddBtn.innerHTML = originalText; }, 1800);
      })
      .catch(function (err) {
        var msg = (err && err.description) || 'Could not add to cart.';
        alert(msg);
        quickAddBtn.innerHTML = originalText;
      })
      .finally(function () {
        quickAddBtn.removeAttribute('aria-disabled');
        quickAddBtn._quickAddPending = false;
      });
  });

  /* ---------------- Quick view modal ---------------- */
  var quickViewModal = document.querySelector('[data-quick-view-modal]');
  if (quickViewModal) {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-view-trigger]');
      if (!trigger) return;
      e.preventDefault();
      var handle = trigger.getAttribute('data-product-handle');
      var content = quickViewModal.querySelector('[data-quick-view-content]');
      content.innerHTML = '<div class="loading-overlay is-active" style="position:static;height:300px;"><span class="spinner"></span></div>';
      window.HomeDecore.openOverlay(quickViewModal);

      fetch('/products/' + handle + '?view=quick-view')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          content.innerHTML = html;
        });
    });
  }
})();
